<template>
  <v-toolbar flat color="primary">
    <v-tooltip bottom>
      <v-toolbar-side-icon @click="load" slot="activator" icon>
        <v-icon>refresh</v-icon>
      </v-toolbar-side-icon>
      <span>Refresh {{module}} List</span>
    </v-tooltip>
    <v-toolbar-title class="hidden-xs-only">
      <h2>{{title}} ({{ totalItems.toLocaleString() }})</h2>
    </v-toolbar-title>
    <v-spacer />
    <v-layout row wrap>
      <v-flex xs12 sm8 offset-sm4>
        <v-text-field
          prepend-inner-icon="search"
          clearable
          hide-details
          single-line
          solo
          color="secondary"
          light
          v-model="searchModel"
          placeholder="Search..."
          class="mx-1"
        />
      </v-flex>
    </v-layout>
    <TableDateFilter @filterCalendar="filterCalendar" />
  </v-toolbar>
</template>

<script>
import TableDateFilter from "../app/TableDateFilter";

export default {
  name: "TableToolbar",

  data() {
    return {
      searchModel: ""
    };
  },

  props: {
    module: String,
    title: String,
    totalItems: Number || String,
    search: String
  },

  components: {
    TableDateFilter
  },

  watch: {
    searchModel(val) {
      this.$emit("setSearch", val);
    }
  },
  methods: {
    filterCalendar(from, to) {
      this.$emit("filterCalendar", from, to);
    },
    load() {
      this.$emit("load");
    }
  }
};
</script>

<style>
</style>
